import React, { useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import { Button } from '../../../../../../Button'
import {
  useSyncShopifyCustomerMutation,
} from '../../../../../../../redux/slices/partnersSlice'

const pending = (message) => ({
  message, display: 'block', color: 'rgb(1, 67, 97)', background: 'rgb(229, 246, 253)',
})
const success = (message) => ({
  message, display: 'block', color: 'rgb(30, 70, 32)', background: 'rgb(237, 247, 237)',
})
const failure = (message) => ({
  message, display: 'block', color: 'rgb(95, 33, 32)', background: 'rgb(253, 237, 237)',
})

function SyncCustomer({ partner, listing }) {
  const [output, setOutput] = useState({ display: 'none' })
  const [syncShopifyCustomer] = useSyncShopifyCustomerMutation()
  const { affiliate } = useOutletContext()

  const {
    message, color, background, display,
  } = output
  return (
    <div style={{ borderBottom: '1px dashed #ccc', paddingBottom: '1em' }}>
      <Grid container>
        <Grid item xs={3}>
          <Button
            label="Sync NetSuite Customer"
            variant="contained"
            color="primary"
            onClick={() => {
              setOutput(pending('...'))
              syncShopifyCustomer({
                Name: listing.name,
                PartnerId: partner.id,
                ListingId: listing.id,
                AffiliateId: affiliate.id,
                ShopifyUrl: partner.sourceKey,
              }).then((res) => setOutput(res.data.success
                ? success(`Sync Request Id: ${res.data.data}`)
                : failure(res.data.errorMessage)))
            }}
          />
        </Grid>
        <Grid item xs={9}>
          <pre
            style={{
              borderRadius: '5px',
              background,
              color,
              display,
              margin: '0',
              padding: '7px',
              whiteSpace: 'pre-wrap',
            }}
          >
            {message}
          </pre>
        </Grid>
      </Grid>
    </div>
  )
}

SyncCustomer.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  partner: PropTypes.shape({
    id: PropTypes.string,
    source: PropTypes.string,
    sourceKey: PropTypes.string,
  }).isRequired,
}

export default SyncCustomer
